import { useNavigate } from "react-router-dom";
import { FileText, Mail, FileSignature, ChevronLeft } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import SettingsTile from "@/components/SettingsTile";
import { Button } from "@/components/ui/button";

const TILES = [
  { title: "Proposal Templates", desc: "Build the pages, pricing and cover of every proposal", accent: "teal", Icon: FileText, tab: "content" },
  { title: "Email Templates", desc: "Sending, chasing, acceptance & internal emails", accent: "indigo", Icon: Mail, tab: "emails" },
  { title: "Engagement (LoE)", desc: "Letter of Engagement content & signing nudges", accent: "violet", Icon: FileSignature, tab: "loe" },
];

export default function SettingsTemplates() {
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Templates & Letters" subtitle="Proposal, email and engagement templates." accent="teal" Icon={FileText}
        actions={<Button variant="outline" onClick={() => navigate("/admin")} data-testid="templates-back"><ChevronLeft className="w-4 h-4 mr-1" />Settings</Button>} />
      <div className="p-4 md:p-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 max-w-[1200px]">
        {TILES.map((t) => <SettingsTile key={t.tab} {...t} onClick={() => navigate(`/admin?tab=${t.tab}`)} />)}
      </div>
    </div>
  );
}
